import { useEffect, useState } from 'react';
import { useCollectionByHandle } from '@backpackjs/storefront';
import { Link } from '../Link';

export function Breadcrumbs({ product }) {
  const [collectionHandle, setCollectionHandle] = useState('shop-all');
  const [collectionObject, setCollectionObject] = useState(null);

  const { fetchCollectionByHandle } = useCollectionByHandle({
    handle: collectionHandle,
    fetchOnMount: false,
  });

  useEffect(() => {
    let handle = 'shop-all';
    if (typeof sessionStorage !== 'undefined') {
      const storedPreviousCollection = sessionStorage?.getItem('PREVIOUS_PATH');
      if (storedPreviousCollection?.includes('/collections/')) {
        handle = storedPreviousCollection.replace('/collections/', '');
        setCollectionHandle(handle);
      }
    }

    fetchCollectionByHandle({
      handle,
    }).then((item) => {
      setCollectionObject(item);
    });
  }, []);

  return (
    <div className="breadcrumbs hidden pb-[30px] text-sm font-light text-primary md:block">
      <ul className="flex gap-2 [&_li:not(:last-child)]:after:content-['/'] [&_li]:after:ml-2 [&_li]:after:inline-block">
        <li>
          <Link href="/">Home</Link>
        </li>
        <li>
          <Link href={`/collections/${collectionHandle}`}>
            {collectionObject?.title}
          </Link>
        </li>
        <li>{product?.title}</li>
      </ul>
    </div>
  );
}
